import { useEffect } from 'react';

function VidasRedirectScreen() {
    useEffect(() => {
        window.location.replace('https://www.unisind.com.br/jmxcorretora/vidas/')
    }, [])
}

export default VidasRedirectScreen;